import React from 'react';
import { useLocaleContext } from '../../../../../context/LocaleContext';
import { useScheduleContext } from '../../../../../context/ScheduleContext';
import DelayCard from '../DelayCard';
import EpisodeCard from '../EpisodeCard';

const PdfCardGrid = ({episode, cardStyles}) => {
    const $locale = useLocaleContext();
    const {pdfSettings} = useScheduleContext();

    if (episode.delay) {
        return !!pdfSettings?.showDelay
        ? (<DelayCard
                episode={episode}
                $locale={$locale}
                className={'pdf-card-grid'}
                cardStyles={cardStyles}
                pdfSettings={pdfSettings}
                isGridCard
            />)
        : null;
    }

    return (
        <EpisodeCard
            episode={episode}
            $locale={$locale}
            className={'pdf-card-grid'}
            cardStyles={cardStyles}
            pdfSettings={pdfSettings}
        />
    )
};

export default PdfCardGrid;
